import Container from "react-bootstrap/Container";

import {
    FaInstagram
} from "react-icons/fa";
import {Stack} from "react-bootstrap";
import {Outlet} from "react-router-dom";

export default function Home() {
    return (
        <Container fluid className={""}>
            <h1 className={"mx-auto mb-3"}>Erika.Tattoo.Art in Tacoma, Washington</h1>
            <Outlet/>
        </Container>
    );
}

// Book Now Button and other actions?
export const ActionContent = () => {


    return (
        <Container>

        </Container>
    );
}